import { z } from "zod";
import {
  REMITTANCE_VERIFICATION_VERDICTS,
  remittanceVerificationFindingSchema,
} from "@erp/shared-types";
import { defineStepConfig } from "../../../registry/helpers";

/**
 * Persist Remittance Verification
 *
 * Adapter that writes the generic `verify_step_output` result onto the
 * remittance advice (`ar_remittance_advice.verification_result`), stamping
 * `verifiedAt`, so the remittance detail page can surface the verdict + findings.
 * Kept separate from `verify_step_output` so that node stays domain-agnostic.
 */
export const persistRemittanceVerificationStep = defineStepConfig({
  type: "persist_remittance_verification",
  name: "Persist Remittance Verification",
  description:
    "Write the verify_step_output result (verdict, summary, findings, taskId) onto the remittance advice.",
  category: "Data Access",
  libraryModule: "AccountsReceivable",
  inputSchema: z.object({
    remittanceAdviceId: z
      .uuid()
      .describe("Remittance advice to store the verification result on"),
    verdict: z
      .enum(REMITTANCE_VERIFICATION_VERDICTS)
      .describe("Overseer verdict from verify_step_output"),
    summary: z.string().describe("One-line summary of the check outcome"),
    findings: z
      .array(remittanceVerificationFindingSchema)
      .describe("Concrete problems the check surfaced (empty on pass)"),
    taskId: z
      .string()
      .nullable()
      .describe("Escalation task id opened on needs_review, or null"),
  }),
  outputSchema: z.object({
    remittanceAdviceId: z.uuid(),
    verdict: z.enum(REMITTANCE_VERIFICATION_VERDICTS),
  }),
  configSchema: z.object({}),
  emits: [] as const,
});
